import {
	connectRequestsCollection,
	usersCollection,
	firebase,
} from '../../config/firebase';

let state = {
	socialSocialUser: {},
	socialSocialUsers: [],
	suggestedUsers: [],
	requestedTo: [],
	requestedBy: [],
	userConnects: [],
	loading: false,
	notification: { message: '', type: '' },
};
let getters = {
	userConnects: state => state.userConnects,
	socialSocialUser: state => state.socialSocialUser,
	socialSocialUsers: state => state.socialSocialUsers,
	suggestedUsers: state => state.suggestedUsers,
	requestedTo: state => state.requestedTo,
	requestedBy: state => state.requestedBy,
	socialSocialUserLoading: state => state.loading,
	socialSocialUserNotification: state => state.notification,
};
let actions = {
	async getSocialUser({ commit }, payload) {
		commit('setSocialUserLoading', true);
		let socialSocialUserSnap = await usersCollection.doc(payload).get();
		let socialSocialUserData = socialSocialUserSnap.data();
		commit('setSocialUserData', {id:socialSocialUserSnap.id, ...socialSocialUserData});
		commit('setSocialUserLoading', false);
	},
	async getSocialUsers({ commit }, payload) {
		commit('setSocialUserLoading', true);
		usersCollection.onSnapshot(snapshot => {
			let socialSocialUsers = [];
			for (let doc of snapshot.docs) {
				if (doc.id != payload)
					socialSocialUsers.push({
						id: doc.id,
						...doc.data(),
					});
			}
			commit('setSocialUsersData', socialSocialUsers);
			commit('setSocialUserLoading', false);
		});
	},
	async getSuggestedUsers({ commit }, payload) {
		commit('setSocialUserLoading', true);
		usersCollection.get().then(snapshot => {
			let socialSocialUsers = [];
			let users = 0;
			snapshot.docs.sort(function() {
				return 0.5 - Math.random();
			});
			for (let doc of snapshot.docs) {
				let data = doc.data();

				let { creator_type } = data;
				if (creator_type) {
					for (let creatorType of creator_type) {
						let isCreatorType = payload.creator_type.includes(
							creatorType
						);
						if (isCreatorType) {
							let obj = payload.connects.find(
								connect => connect == doc.id
							);
							
							if (!obj) {
								users++;
								if (payload.id != doc.id) {
									socialSocialUsers.push({
										id: doc.id,
										...doc.data(),
									});
								}
								break;
							}
						}
					}
				}
				if (users > 3) {
					break;
				}
			}
			commit('setSuggestedUsersData', socialSocialUsers);
			commit('setSocialUserLoading', false);
		});
	},
	async sendConnectRequest({ commit, dispatch }, payload) {
		await connectRequestsCollection.add({
			...payload,
			datetime: firebase.firestore.Timestamp.fromDate(new Date()),
		});
		dispatch('setNotification', {
			message: 'You recieved connect request from',
			for: payload.requested_to,
			user: payload.requested_by,
			type: 'connect',
		});
		commit('setSocialUsersNotification', {
			message: 'Connected',
			type: 'success',
		});
	},
	async disconnect({ commit }, payload) {
		let user1 = await usersCollection.doc(payload.user1).get();
		let user2 = await usersCollection.doc(payload.user2).get();
		let user1Data = user1.data();
		let user2Data = user2.data();
		let { connects: user1Connects } = user1Data;
		let { connects: user2Connects } = user2Data;
		user1Connects = user1Connects.filter(
			userConnect => userConnect != payload.user2
		);
		user2Connects = user2Connects.filter(
			userConnect => userConnect != payload.user1
		);
		user1Data['connects'] = user1Connects;
		user2Data['connects'] = user2Connects;
		await usersCollection.doc(payload.user1).update({ ...user1Data });
		await usersCollection.doc(payload.user2).update({ ...user2Data });
		commit('setSocialUsersNotification', {
			message: 'Disconnected',
			type: 'success',
		});
	},
	async getRequestSent({ commit }, payload) {
		connectRequestsCollection
			.where('requested_by', '==', payload)
			.onSnapshot(snapshot => {
				let sentRequests = [];
				for (let doc of snapshot.docs) {
					sentRequests.push({ id: doc.id, ...doc.data() });
				}
				commit('setRequestedBy', sentRequests);
			});
	},
	// async getRequestRecieved({ commit }, payload) {
	// 	connectRequestsCollection
	// 		.where('requested_to', '==', payload)
	// 		.onSnapshot(snapshot => {
	// 			let sentRecieved = [];
	// 			for (let doc of snapshot.docs) {
	// 				sentRecieved.push({ id: doc.id, ...doc.data() });
	// 			}
	// 			commit('setRequestedTo', sentRecieved);
	// 		});
	// },
	async getRequestRecieved({ commit }, payload) {
		connectRequestsCollection
			.where('requested_to', '==', payload)
			.onSnapshot(async snapshot => {
				let sentRecieved = [];
				for (let doc of snapshot.docs) {
					let data = doc.data();
					let { requested_by, requested_to } = data;
					let requestBySnap = await usersCollection
						.doc(requested_by)
						.get();
					let requestToSnap = await usersCollection
						.doc(requested_to)
						.get();
					let requestByData = requestBySnap.data();
					let requestToData = requestToSnap.data();
					data = { ...data, requestByData, requestToData };
					sentRecieved.push({ id: doc.id, ...data });
				}
				commit('setRequestedTo', sentRecieved);
			});
	},
	async cancelRequest({ commit }, payload) {
		let connectionSnaps = await connectRequestsCollection
			.where('requested_by', '==', payload.requested_by)
			.where('requested_to', '==', payload.requested_to)
			.get();
		for (let doc of connectionSnaps.docs) {
			await connectRequestsCollection.doc(doc.id).delete();
		}
	},
	async acceptRequest({ commit, dispatch }, payload) {
		
		let user1 = await usersCollection.doc(payload.requested_by).get();
		let user2 = await usersCollection.doc(payload.requested_to).get();
		let user1Data = user1.data();
		let user2Data = user2.data();
		let user1Connects = user1Data.connects;
		let user2Connects = user2Data.connects;
		user1Connects = user1Connects ? user1Connects : [];
		user2Connects = user2Connects ? user2Connects : [];
		user1Connects.push(payload.requested_to);
		user2Connects.push(payload.requested_by);
		user1Data['connects'] = user1Connects;
		user2Data['connects'] = user2Connects;
		
		
		await usersCollection
			.doc(payload.requested_by)
			.update({ ...user1Data });
		await usersCollection
			.doc(payload.requested_to)
			.update({ ...user2Data });
		let connectionSnaps = await connectRequestsCollection
			.where('requested_by', '==', payload.requested_by)
			.where('requested_to', '==', payload.requested_to)
			.get();
		for (let doc of connectionSnaps.docs) {
			await connectRequestsCollection.doc(doc.id).delete();
		}
		dispatch('setNotification', {
			message: 'Your connect request accepted by',
			for: payload.requested_by,
			user: payload.requested_to,
			type: 'connect',
		});
	},
	async rejectRequest({ commit }, payload) {
		let connectionSnaps = await connectRequestsCollection
			.where('requested_by', '==', payload.requested_by)
			.where('requested_to', '==', payload.requested_to)
			.get();
		for (let doc of connectionSnaps.docs) {
			await connectRequestsCollection.doc(doc.id).delete();
		}
	},
	async getConnects({ commit }) {
		let { connects } = JSON.parse(localStorage.getItem('authUser'));
		let finalizedConnects = [];
		for (let connect of connects) {
			let userSnap = await usersCollection.doc(connect).get();
			let userData = userSnap.data();
			userData['name'] = userData.firstname + ' ' + userData.lastname;
			finalizedConnects.push({ id: userSnap.id, ...userData });
		}
		commit('setSocialUserConnectsData', finalizedConnects);
	},
};
let mutations = {
	setRequestedBy(state, payload) {
		state.requestedBy = payload;
	},
	setSuggestedUsersData(state, payload) {
		state.suggestedUsers = payload;
	},
	setRequestedTo(state, payload) {
		state.requestedTo = payload;
	},
	setSocialUserConnectsData(state, payload) {
		state.userConnects = payload;
	},
	setSocialUserData(state, payload) {
		state.socialSocialUser = payload;
	},
	setSocialUsersData(state, payload) {
		state.socialSocialUsers = payload;
	},
	setFeaturedSocialUserData(state, payload) {
		state.featuredSocialUsers = payload;
	},
	setSocialUserLoading(state, payload) {
		state.loading = payload;
	},
	setSocialUsersNotification(state, payload) {
		let { notification } = state;
		notification.message = payload.message;
		notification.type = payload.type;
		state.notification = notification;
		window.setTimeout(() => {
			let obj = { message: '', type: '' };
			state.notification = obj;
		}, 5000);
	},
};
export default { state, getters, actions, mutations };
